
/// <amd-module name="DistributedTaskUI/Logs/LiveLogsParser" />
import { ILogLine, LogType } from "DistributedTaskUI/Logs/Logs.Types";
import * as Resources from "DistributedTaskUI/Logs/Resources";

export class LiveLogsParser {

    public static formatLogLine(logLine: string): ILogLine[] {
        const consoleLineMarking = "******************************************************************************";
        let formattedLogLines: ILogLine[] = [];

        const matches: RegExpExecArray | null = LiveLogsLineRegEx.exec(logLine);
        if (!!matches && matches.length > 2) {
            const logType: LogType = this._getLogType(matches[1].toLowerCase());
            const text: string = matches[2];

            if (logType === LogType.Section) {
                formattedLogLines.push({ content: consoleLineMarking, logType: logType } as ILogLine);
                formattedLogLines.push({ content: text, logType: logType } as ILogLine);
                formattedLogLines.push({ content: consoleLineMarking, logType: logType } as ILogLine);
            }
            else {
                formattedLogLines.push({ content: text, logType: logType } as ILogLine);
            }
        }
        else {
            // no tag found
            formattedLogLines.push({ content: logLine, logType: LogType.Default } as ILogLine);
        }

        return formattedLogLines;
    }

    private static _getLogType(logTypeText: string): LogType {
        switch (logTypeText) {
            case "command":
                return LogType.Command;
            case "debug":
                return LogType.Debug;
            case "error":
                return LogType.Error;
            case "warning":
                return LogType.Warning;
            case "section":
                return LogType.Section;
            default:
                return LogType.Default;
        }
    }
}

export const LiveLogsLineRegEx: RegExp = /^\#+\[([^|\s\]]+).*?\](.*)/;

export const StaticLogTokenizer = [
    { regex: new RegExp("##\\[[E|e]rror[^\\]]*\].*"), action: { token: "error-token" } },
    { regex: new RegExp("##\\[[W|w]arning[^\\]]*\].*"), action: { token: "warn-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[E|e]rror[^\\]]*\].*"), action: { token: "error-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[W|w]arning[^\\]]*\].*"), action: { token: "warn-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[I|i]nfo[^\\]]*\].*"), action: { token: "info-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[S|s]ection[^\\]]*\].*"), action: { token: "section-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[C|c]ommand[^\\]]*\].*"), action: { token: "command-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[D|d]ebug[^\\]]*\].*"), action: { token: "debug-token" } },
    { regex: new RegExp("(.{27}Z )?##\\[[V|v]erbose[^\\]]*\].*"), action: { token: "info-token" } },
    { regex: new RegExp(Resources.TaskLogViewLimitExceededMessage), action: { token: "error-token" } }
];

export const LiveLogsTokenizer = [
    { regex: new RegExp("\\[[E|e]rror[^\\]]*\].*"), action: { token: "error-token" } },
    { regex: new RegExp("\\[[W|w]arning[^\\]]*\].*"), action: { token: "warn-token" } },
    { regex: new RegExp("\\[[I|i]nfo[^\\]]*\].*"), action: { token: "info-token" } },
    { regex: new RegExp("\\[[S|s]ection[^\\]]*\].*"), action: { token: "section-token" } },
    { regex: new RegExp("\\[[C|c]ommand[^\\]]*\].*"), action: { token: "command-token" } },
    { regex: new RegExp("\\[[D|d]ebug[^\\]]*\].*"), action: { token: "debug-token" } },
    { regex: new RegExp("\\[[V|v]erbose[^\\]]*\].*"), action: { token: "info-token" } }
];
